import { render, staticRenderFns } from "./viewDashboard.vue?vue&type=template&id=1f9e54ff&scoped=true&"
import script from "./viewDashboard.vue?vue&type=script&lang=js&"
export * from "./viewDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9e54ff",
  null
  
)

export default component.exports